import Visibility from "@mui/icons-material/Visibility";
import { useState } from "react";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment, TextField } from "@mui/material";

export default function InputField({
  label,
  placeholder,
  type,
  background,
  onKeyDown,
  helperText,
  passwordError,
  passwordHint,
  onBlur,
  shrink,
  size,
  startAdornment,
  required,
  name,
  onChange,
  width,
  value,
  defaultValue,
  max,
  disabled,
  sx,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmedPassword, setShowConfirmedPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmedPassword(!showConfirmedPassword);

  if (type === "password") {
    return (
      <div>
        <TextField
          sx={{
            ...sx,
            margin: "10px 0",
            width: "100%",
          }}
          size={size}
          required={required}
          label={label}
          value={value}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          color="primary"
          error={passwordError}
          helperText={
            passwordError
              ? passwordHint ||
                "Password must be at least six characters long and contain at least one letter, one number, and one symbol"
              : ""
          }
          placeholder={placeholder}
          type={showPassword ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                >
                  {showPassword ? <Visibility sx={{color:"#000"}}/> : <VisibilityOff  sx={{color:"#000"}}/>}
                </IconButton>
              </InputAdornment>
            ),

            style: { fontSize: 12, height: "46px" },
          }}
          InputLabelProps={{ style: { fontSize: 12 } }}
        />
      </div>
    );
  } else if (type === "confirmPassword") {
    return (
      <div>
        <TextField
          sx={{
            ...sx,
            margin: "10px 0",
            width: "100%",
          }}
          label={label}
          name={name}
          value={value}
          onChange={onChange}
          color="primary"
          onBlur={onBlur}
          error={passwordError}
          helperText={
            passwordError
              ? "Password and confirm password should be the same"
              : ""
          }
          placeholder={placeholder}
          type={showConfirmedPassword ? "text" : "password"}
          size={size}
          required={required}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowConfirmPassword}
                >
                  {showConfirmedPassword ? <Visibility sx={{color:"#000"}} /> : <VisibilityOff sx={{color:"#000"}} />}
                </IconButton>
              </InputAdornment>
            ),
            startAdornment:startAdornment,
            style: { fontSize: 12, height: "46px" },
          }}
          InputLabelProps={{ style: { fontSize: 12 } }}
        />
      </div>
    );
  } else {
    return (
      <div>
        <TextField
          sx={
            sx
              ? sx
              : {
                  margin: "10px 0",
                  width: width ? width : "100%",
                }
          }
          label={label}
          onKeyDown={onKeyDown}
          type={type}
          color="primary"
          required={!!required}
          helperText={helperText}
          // value={value}
          defaultValue={defaultValue}
          inputProps={{ max: max, min: 0 }}
          name={name}
          onChange={onChange}
          disabled={disabled}
          size={size}
          placeholder={placeholder}
          InputProps={{
            style: { fontSize: 12, height: "46px", background: background },
          }}
          InputLabelProps={{ style: { fontSize: 12 } }}
        />
      </div>
    );
  }
}
